import React, { useMemo } from 'react';
import { TableCell as MuiTableCell } from '@mui/material';

import { IColumn } from 'components/Table/types';
import { TableTypes } from 'components/Table/constants';

import { ReactComponent as CheckIcon } from 'assets/check.icon.svg';
import { ReactComponent as CrossIcon } from 'assets/cross.icon.svg';

import useStyles from '../styles';
import { getFormattedDate } from 'utils/dates';

interface ITableCellProps {
  rowData: any;
  column: IColumn;
  data: string | number | boolean;
}

const TableCell: React.FC<ITableCellProps> = ({ data, column, rowData }) => {
  const classes = useStyles();

  const content = useMemo(() => {
    switch (column.type) {
      case TableTypes.boolean:
        return (
          <>
            {data ? (
              <CheckIcon className={classes.checkIcon} />
            ) : (
              <CrossIcon className={classes.crossIcon} />
            )}
          </>
        );
      case TableTypes.actions:
        return <>{data}</>;
      case TableTypes.custom:
        return <>{column?.accessor && column?.accessor(rowData)}</>;
      case TableTypes.date:
        return getFormattedDate(String(data));
      default:
        return <>{data}</>;
    }
  }, [column?.accessor, column.type]);

  return (
    <MuiTableCell
      className={classes.tableCell}
      style={{
        maxWidth: column.width ? `${column.width}px` : '100%',
      }}
    >
      {content}
    </MuiTableCell>
  );
};

export default TableCell;
